export enum DeviceType {
  "Mobile",
  "Tablet",
  "Desktop",
}
